import React, { ChangeEvent, useState, Dispatch, SetStateAction } from 'react';
// import Img from './inactive.png';
import './lockscreen.css';
import './animate.css';
import LSTextbox from './component/Textbox';
import LSButton from './component/Button';
import { faUserClock, faUserCog } from '@fortawesome/free-solid-svg-icons';
import Logo from '../resources/images/logo-automedsys.png';
import { formState } from '../pages/SignIn/SignInModel';
import { UpdateStorage } from '../pages/SignIn/';
import * as Service from '../services';
import * as Constants from '../constants';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { getItemStore, setItemStore } from '../Utilities/appHelpers';

export interface LockProps {
   Lock: boolean;
   setLock: Dispatch<SetStateAction<boolean>>;
   setActive: () => void;
   UserName: string | null;
   Image: string;
   anim: string;
   setAnim: Dispatch<SetStateAction<string>>;
}

const LockScreen = (props: LockProps) => {
   const history = useHistory();
   const LogOut = () => {
      sessionStorage.clear();
      history.push('/');
   };

   const theme = useTheme();
   const primain: string = theme.palette.primary.main;
   const { UserName, Lock, setLock, setActive, Image, setAnim, anim } = props;
   if (Lock) {
      const [passw, setPassw] = useState('');
      const [loading, setLoading] = useState('');
      const [textStatus, disableTextStatus] = useState(false);

      const Reautenticate = async () => {
         if (passw.trim() === '') {
            //error- Invalid Password
            toast.error('Your Password is Required', {
               position: toast.POSITION.TOP_RIGHT,
               autoClose: 5000,
            });
            return;
         }

         //get the username and practics id
         const uname: string | null = getItemStore('AUTOMEDSYS_LUN');
         const practRef: string | null = getItemStore('AUTOMEDSYS_PRACREF');
         if (uname === null || practRef === null) {
            //invalid storage valuse
            toast.error('We have trouble reading your Login Credentials. You will be Signed Out.', {
               position: toast.POSITION.TOP_RIGHT,
               autoClose: 5000,
            });
            LogOut();

            return;
         }

         setLoading('loading');
         disableTextStatus(true);
         //authenticate from back end, update browser local storage as required
         const values: formState = { Username: uname, Password: passw, PracticeRefNumber: practRef };

         //verify from backend
         try {
            const res = await Service.userLogin(values, Constants.IDENTITY, Constants.CONNECT_TOKEN);
            if (res.status === 200) {
               //Y=>Keep the username(email) in local storage
               //************************************ */
               setItemStore('AUTOMEDSYS_LUN', values.Username);
               //************************************ */
               UpdateStorage(res);
               setAnim('zoomOutShort2');
               setTimeout(() => {
                  setLock(false);
               }, 1000);
               setActive();
               toast.success('Welcome Back', {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 5000,
               });
            }
         } catch (error: any) {
            //console.log(error);
            if (error.response && error.response.data) {
               const message = error.response.data.UserErrorMessage;

               if (message) {
                  toast.error(message, {
                     position: toast.POSITION.TOP_RIGHT,
                     autoClose: 5000,
                  });
               } else {
                  toast.error('Request Failed, Please Try Again!', {
                     position: toast.POSITION.TOP_RIGHT,
                     autoClose: 5000,
                  });
               }
            } else {
               toast.error('Invalid Response, Check your Internet', {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 5000,
               });
            }

            setLoading('');
            disableTextStatus(false);
         }
      };
      return (
         <div className={'ams-lkscr animated ' + anim}>
            <div className="ams-lkscr-cont">
               <div className="ams-lkscr-imgbx zoomInShort animated fast delay-0-5s">
                  <img src={Image} alt="Inactive" />
               </div>
               <h1 className="mainTitle useFont zoomInShort animated fast delay-0-7s" style={{ color: primain }}>
                  <div>
                     Ohh!!! <span className="deep-color">{UserName}</span>
                  </div>
                  <div>you&apos;ve not been active</div>
               </h1>
               <h2 className="contTitle useFont zoomInShort animated fast delay-0-8s">
                  No worries!! Provide your password, let&apos;s get you back
               </h2>
               <form onSubmit={Reautenticate} action="javascript:void(0)">
                  <LSTextbox
                     Type="password"
                     Value={passw}
                     setValue={setPassw}
                     ClassN="fadeInUp animated fast delay-1s"
                     Placeholder="Password"
                     ID="lspassw"
                     Disabled={textStatus}
                     MainColor={primain}
                  />
                  <LSButton
                     ID="aut-btn"
                     Text="Re-Authenticate"
                     TextAlt="Authenticating ..."
                     Logo={faUserClock}
                     LogoAlt={faUserCog}
                     State={loading}
                     ClassN="fadeInUp animated fast delay-1-2s"
                     MainColor={primain}
                  />
               </form>
               <div style={{ textAlign: 'center', marginTop: '5px' }}>
                  <button className="ams-ls-link fadeInUp animated fast delay-1-5s useFont" onClick={LogOut}>
                     Logout
                  </button>
               </div>
            </div>
            <div className="ams-footer-logo">
               <img src={Logo} alt="AutoMedSys" />
            </div>
         </div>
      );
   } else {
      return null;
   }
};

export default LockScreen;
